import React from "react";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";

//
import PageTop from "../../sections/PageTop";
import FaqList from "./sections/FaqList";
import AppoinmentSection from "../../components/appointment-section/AppoinmentSection";
import MainReview from "../main/sections/MainReview";
import AboutClinicForm from "../aboutClinic/sections/AboutClinicForm";
import Location from "../../sections/Location";

const linkChain = [
  {
    id: uuidv4(),
    title: "navHome",
    to: "/",
  },
  {
    id: uuidv4(),
    title: "footerAboutFAQ",
  },
];

export default function Faq() {
  const { t } = useTranslation();

  return (
    <StyledFaq>
      <PageTop title={t("faqTitle")} linkList={linkChain} />
      <FaqList />
      <AppoinmentSection />
      <MainReview />
      <AboutClinicForm />
      <Location />
    </StyledFaq>
  );
}

const StyledFaq = styled.main``;
